import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PropertyListRow = _resolveComponent("PropertyListRow")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.state.project && _ctx.state.data)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        style: {"max-width":"1400px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Header),
          _createVNode(_component_v_card, { class: "mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_table, {
                class: "properties-table",
                style: {"min-width":"1000px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[0] || (_cache[0] = _createElementVNode("th", { class: "text-start" }, "Property", -1)),
                      _cache[1] || (_cache[1] = _createElementVNode("th", { class: "text-start" }, "Criterion", -1)),
                      _cache[2] || (_cache[2] = _createElementVNode("th", { class: "text-start" }, "Aim", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c_alternativesIds, (alternativeId, index) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: index,
                          class: "text-center"
                        }, _toDisplayString(_ctx.getAlternativeById(alternativeId).name), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getNormalizedItemsByUniqueItemProp('property'), (items, property) => {
                      return (_openBlock(), _createBlock(_component_PropertyListRow, {
                        key: property,
                        items: items,
                        property: property
                      }, null, 8, ["items", "property"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}